import React from "react";
import { ImageIcon } from "@fluentui/react/lib/Icon";
import { registerIcons } from "@fluentui/style-utilities";
import type { AddinCommandSurfaceItem } from "owa-addins-types";

const AddinIcons = new Set<string>();

const preventContextMenu = (ev: React.MouseEvent<HTMLElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
};

export function getAddinIcon(addIn: AddinCommandSurfaceItem): string | undefined {
    const encodeRegisterKey = (surfaceAddIn: AddinCommandSurfaceItem) => `AddIn_${(surfaceAddIn?.id ?? surfaceAddIn?.name)?.replace(/\s/g, "_")}`;
    const iconName = encodeRegisterKey(addIn);
    
    if (!AddinIcons.has(iconName)) {
        if (!addIn?.iconProps || !addIn.iconProps?.imageProps || !addIn.iconProps.imageProps?.src) {
            return undefined;
        }
        
        /* oxlint-disable-next-line react-perf/jsx-no-new-object-as-prop -- (https://aka.ms/OWALintWiki)
         * Fix this by memoizing or hoisting the object so its identity remains stable across renders.
         * > JSX attribute values should not contain objects created in the same scope. */
        const imageProps = {
            ...addIn.iconProps?.imageProps,
            // Sensible overrides for the image icons to match other ribbon's font icon buttons.
            width: "85%",
            height: "85%",
        };
        
        const Icon = () => {
            return <ImageIcon imageProps={imageProps} onContextMenu={preventContextMenu}/>;
        };
        
        registerIcons({
            icons: {
                [iconName]: <Icon />,
            },
        });
        
        AddinIcons.add(iconName);
    }
    
    return iconName;
}
